export default "__VITE_ASSET__Bj1Xjy9X__"